import { FlightplanId } from "@poscon/shared-types";
import { ComponentType } from "react";
import { useRootSelector } from "~/redux/hooks";
import { flightplanSelector } from "~/redux/slices/aircraftSlice";
import { Asel } from "~/types/asel";
import { EdstAselMenu } from "~/types/edstView";
import { PlanOptions } from "./views/PlanOptions";
import {
  AltitudeMenu,
  EdstAircraftMenuProps,
  FreeTextMenu,
  HeadingMenu,
  HoldMenu,
  PreviousRouteMenu,
  RouteMenu,
  SpeedMenu,
  XResMenu,
} from "./menus/AircraftMenu";
import { PoMenu } from "./prompts/PoMenu";
import { cpdlcMiniMOView, cpdlcPidView, cpdlcTocHeldView } from "@poscon/shared-frontend";
import { CpdlcMiniMOPrompt } from "./views/CpdlcMiniMO";
import { CpdlcTocHeldPrompt } from "./prompts/CpdlcTocHeldPrompt";
import { ProbeMenu } from "./views/ProbeMenu";

const flightplanMenuMap: Record<EdstAselMenu, ComponentType<EdstAircraftMenuProps> | null> = {
  ALTITUDE_MENU: AltitudeMenu,
  CANCEL_HOLD_MENU: null,
  CHANGE_DEST_MENU: null,
  HEADING_MENU: HeadingMenu,
  HOLD_MENU: HoldMenu,
  PLAN_OPTIONS: PlanOptions,
  PO_MENU: PoMenu,
  PREV_ROUTE_MENU: PreviousRouteMenu,
  FREETEXT_MENU: FreeTextMenu,
  ROUTE_MENU: RouteMenu,
  SPEED_MENU: SpeedMenu,
  X_RES_MENU: XResMenu,
  PROBE_MENU: ProbeMenu,
  TRIAL_RESTRICTIONS_MENU: null,
  [cpdlcMiniMOView]: CpdlcMiniMOPrompt,
  [cpdlcPidView]: null,
  [cpdlcTocHeldView]: CpdlcTocHeldPrompt,
} as const;

type AselComponentProps = {
  asel: Asel;
};

export const AselComponent = ({ asel }: AselComponentProps) => {
  const fp = useRootSelector((state) => flightplanSelector(state, asel.fpId));

  const Component = asel?.menu ? flightplanMenuMap[asel.menu] : null;

  return fp && Component ? <Component key={asel.fpId} fp={fp} asel={asel} /> : null;
};
